import { HttpStatusCode } from 'axios';
import { ValidationError } from '../types';

export const getErrorStatus = (
  error: ValidationError | null
): number | null => {
  if (!error?.response?.status) {
    return null;
  }
  return error.response.status;
};

export const isRateLimitError = (error: ValidationError | null): boolean =>
  getErrorStatus(error) === HttpStatusCode.TooManyRequests;

export const isServerError = (error: ValidationError | null): boolean => {
  const status = getErrorStatus(error);
  return status !== null && status >= HttpStatusCode.InternalServerError;
};

export const isClientError = (error: ValidationError | null): boolean => {
  const status = getErrorStatus(error);
  return (
    status !== null &&
    status >= HttpStatusCode.BadRequest &&
    status < HttpStatusCode.InternalServerError
  );
};

export const getErrorMessage = (error: ValidationError | null): string => {
  if (!error) return '';

  if (error.message) {
    return error.message;
  }

  const status = getErrorStatus(error);
  switch (status) {
    case HttpStatusCode.TooManyRequests:
      return 'Too many requests. Please wait before trying again.';
    case HttpStatusCode.InternalServerError:
      return 'Server error. Please try again later.';
    case HttpStatusCode.NotFound:
      return 'Resource not found.';
    default:
      return 'An unexpected error occurred.';
  }
};
